import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-573ed85c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-embed-inner" }
const _hoisted_2 = ["poster", "aria-label", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "video-embed",
    style: _normalizeStyle(_ctx.style)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.url)
        ? (_openBlock(), _createElementBlock("video", {
            key: 0,
            ref: "videoRef",
            poster: _ctx.poster,
            class: _normalizeClass({'bg-wild-sand': !_ctx.poster}),
            role: "application",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "aria-label": _ctx.title,
            src: _ctx.url
          }, null, 10, _hoisted_2))
        : _createCommentVNode("", true)
    ])
  ], 4))
}